export const PROPERTY_TYPES = {
  APARTMENT: 'apartment',
  HOUSE: 'house',
}

export const PROPERTY_RISKS = {
  DESIGN_AND_ENGINEERING_EQUIPMENT: 'stylingAndEngineeringEquipment',
  MOVABLE_PROPERTY: 'movableEstate',
  BEARING_STRUCTURES: 'bearingStructures',
  CIVIL_LIABILITY: 'civilLiability',
}

export const PROPERTY_MAIN_RISKS = {
  [PROPERTY_TYPES.APARTMENT]: {
    [PROPERTY_RISKS.DESIGN_AND_ENGINEERING_EQUIPMENT]: true,
    [PROPERTY_RISKS.MOVABLE_PROPERTY]: true,
    [PROPERTY_RISKS.CIVIL_LIABILITY]: true,
  },
  [PROPERTY_TYPES.HOUSE]: {
    [PROPERTY_RISKS.DESIGN_AND_ENGINEERING_EQUIPMENT]: true,
    [PROPERTY_RISKS.MOVABLE_PROPERTY]: true,
  }
}

export const PROPERTY_EXTRA_RISKS = {
  [PROPERTY_TYPES.APARTMENT]: {},
  [PROPERTY_TYPES.HOUSE]: {
    [PROPERTY_RISKS.BEARING_STRUCTURES]: true,
    [PROPERTY_RISKS.CIVIL_LIABILITY]: true
  }
}

export const PROPERTY_CALCULATOR_PRICE_SECTION_OPTIONS = {
  basePrice: {
    showPrice: false,
  },
  finalPrice: {
    showPrice: false,
  },
  overallPrice: {
    showPrice: true,
    translation: 'propertyCalculator.amountLabel',
  },
};

